import { createSvgIcon } from "@mui/material";

export const MarginLeftIcon = createSvgIcon(
  <svg viewBox="0 0 11 12" fill="none">
    <path
      fill="currentColor"
      d="M0 .633C0 .29.264 0 .633 0c.343 0 .633.29.633.633v10.234c0 .37-.29.633-.633.633A.61.61 0 0 1 0 10.867zm4.638 6.961h4.219V3.906H4.638zM3.373 3.906c0-.685.553-1.265 1.265-1.265h4.219c.685 0 1.266.58 1.266 1.265v3.688c0 .712-.58 1.265-1.266 1.265H4.638a1.25 1.25 0 0 1-1.265-1.265z"
    />
  </svg>,
  "MarginLeftIcon",
);
